import { styled } from '@mui/material/styles';
import { useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';
import ScrollToTop from '../../components/scroll-to-top';
import Footer from '../footer';
import AdminNavbar from './AdminNavbar';
import AdminSidebar from './AdminSidebar';


const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 10;

const RootStyle = styled('div')({
  display: 'flex',
  height: '100%',
});

const MainStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  overflow: 'auto',
  height: '100%',
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 8,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  minWidth: 0
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  width: '100%',
  padding: theme.spacing(6),
  paddingTop: APP_BAR_MOBILE + 24,
  transition: 'padding .25s ease-in-out',
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4)
  }
}))

export default function AdminLayout() {
  const [open, setOpen] = useState(false)
  const mainRef = useRef(null)
  
  return (
    <RootStyle>
      <AdminNavbar onOpenSidebar={() => setOpen(true)} />
      <AdminSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
      <MainStyle ref={mainRef}>
        <ContentWrapper className='layout-page-content'
          sx={{
            ...({
              mx: 'auto',
              // '@media (min-width:1440px)': { maxWidth: 1440 },
              '@media (min-width:1440px)': { maxWidth: '100%' },
              '@media (min-width:1200px)': { maxWidth: '100%' }
            })
          }}>
          <Outlet />
        </ContentWrapper>
        <Footer />
        <ScrollToTop className='mui-fixed' mainRef={mainRef}/>
      </MainStyle>
    </RootStyle>
  );
}
